module.exports = __webpack_public_path__ + "img/electronic_enabled.7839f4a0.svg";